import { render, staticRenderFns } from "./RejectedQuoteList.vue?vue&type=template&id=06653ca8&"
import script from "./RejectedQuoteList.vue?vue&type=script&lang=js&"
export * from "./RejectedQuoteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports